module.exports = __webpack_public_path__ + "img/401.8ccca4c7.svg";